import { ServicePrivileges } from 'src/modules/professionals/privileges.js'

export const professionalsRoute = [
  {
    path: '/s/:structureIndex',
    component: () => import('src/modules/core/layout/LayoutProfessional.vue'),
    props: true,
    children: [
      // Accueil
      {
        path: '',
        name: 'professional-homepage',
        component: () => import('src/modules/core/views/ProfessionalHomepage.vue')
      },
      // Structure
      {
        path: 'structure',
        name: 'my-structure',
        meta: {
          title: 'Mon établissement',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/structures/views/Establishment.vue')
      },
      // Objets connectés
      {
        path: 'devices',
        name: 'my-devices',
        meta: {
          title: 'Objets connectés',
          requiredPrivileges: [ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/iot/views/DevicesView.vue')
      },
      // Facturation
      {
        path: 'billing',
        name: 'billing',
        meta: {
          title: 'Facturation',
          requiredPrivileges: [ServicePrivileges.Accountant.value]
        },
        component: () => import('src/modules/professionals/views/BillingPage.vue')
      },
      // Alertes
      {
        path: 'alerts',
        name: 'alerts',
        redirect: { name: 'alerts-list' },
        children: [
          {
            path: '',
            name: 'alerts-list',
            meta: {
              title: 'Alertes'
            },
            component: () => import('src/modules/alerts/views/AlertsPage.vue')
          },
          {
            path: 'alerts-batch/:id',
            name: 'alerts-batch-context',
            props: true,
            meta: {
              title: 'Contexte de l\'alerte'
            },
            component: () => import('src/modules/alerts/views/AlertsBatchPage.vue')
          }
        ]
      },
      {
        path: 'patient/:patientId/documents/:documentId',
        name: 'patient-document-view',
        props: true,
        meta: {
          title: 'Consulter un document d\'identité',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
        },
        component: () => import('src/modules/documents/views/DocumentView.vue')
      },
      // Protocoles médicaux
      {
        path: 'medical-protocols',
        name: 'medical-protocols',
        redirect: { name: 'medical-protocols-list' },
        children: [
          {
            path: '',
            name: 'medical-protocols-list',
            meta: {
              title: 'Protocoles Médicaux',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Prescriber.value, ServicePrivileges.Manager.value]
            },
            component: () => import('src/modules/medical-protocol/views/MedicalProtocols.vue')
          },
          {
            path: ':medicalProtocolId',
            name: 'medical-protocol-view',
            props: true,
            meta: {
              title: 'Protocole Médical',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Prescriber.value, ServicePrivileges.Manager.value]
            },
            component: () => import('src/modules/medical-protocol/views/MedicalProtocolView.vue')
          },
          {
            path: ':medicalProtocolId/documents/:documentId',
            name: 'medical-protocol-view-document-view',
            props: true,
            meta: {
              title: 'Consulter un document',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Prescriber.value, ServicePrivileges.Manager.value]
            },
            component: () => import('src/modules/documents/views/DocumentView.vue')
          }
        ]
      },
      // Dossiers de télésuivi
      {
        path: 'patient-file',
        component: () => import('src/modules/core/components/AppRouterView.vue'),
        children: [
          {
            path: '',
            name: 'patient-file-list',
            meta: {
              title: 'Dossiers patients',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/ListPatientFilesPage.vue')
          },
          {
            path: ':patientFileId',
            props: true,
            meta: {
              title: 'Dossier patient',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/PatientFilePage.vue'),
            children: [
              {
                name: 'patient-file-synthesis',
                path: 'synthesis',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileSynthesisTab.vue')
              },
              {
                name: 'patient-file-alerts',
                path: 'alerts',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileAlertsTab.vue')
              },
              {
                name: 'patient-file-dialysis',
                path: 'dialysis',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileDialysisTab.vue')
              },
              {
                name: 'patient-file-messages',
                path: 'messages',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileMessagesTab.vue')
              },
              {
                name: 'patient-file-documents',
                path: 'documents',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileDocumentsTab.vue')
              },
              {
                name: 'patient-file-activity',
                path: 'activity',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileHistoryTab.vue')
              },
              {
                name: 'patient-file-iot',
                path: 'iot',
                component: () => import('src/modules/patient-files/views/Tabs/PatientFileIotDevicesTab.vue')
              },
              {
                path: '',
                name: 'patient-file-view',
                redirect: { name: 'patient-file-synthesis' }
              }
            ]
          },
          {
            path: ':patientFileId/documents/:documentId',
            name: 'patient-file-view-document-view',
            props: true,
            meta: {
              title: 'Consulter un document',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/documents/views/DocumentView.vue')
          },
          {
            path: ':patientFileId/cpia-payload/:cpiaPayloadId',
            name: 'patient-file-cpia-payload-view',
            props: true,
            meta: {
              title: 'Données CPIA',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/PatientFileCpiaPayload.vue')
          },
          {
            path: ':patientFileId/medial-payload/:medialPayloadId',
            name: 'patient-file-medial-payload-view',
            props: true,
            meta: {
              title: 'Données Médial',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/PatientFileMedialPayload.vue')
          },
          {
            path: ':patientFileId/dialysis-session-payload/:payloadId',
            name: 'patient-file-dialysis-session-payload-view',
            props: true,
            meta: {
              title: 'Données de séance',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/PatientFileDialysisSessionPayload.vue')
          },
          {
            path: ':patientFileId/clinical_document_payloads/:clinicalPayloadId',
            name: 'patient-file-clinical-payload-view',
            props: true,
            meta: {
              title: 'Données de biologie',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/PatientFileBiologyPayload.vue')
          },
          {
            path: ':patientFileId/exercise-payload/:payloadType/:payloadId',
            name: 'patient-file-cognitive-exercise-payload-view',
            props: true,
            meta: {
              title: 'Exercice cognitif',
              requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
            },
            component: () => import('src/modules/patient-files/views/PatientFileCognitiveExercisePayload.vue')
          }
        ]
      },
      // Validation de contenu
      {
        path: 'surveys/:id/validation',
        name: 'survey-validation',
        props: true,
        meta: {
          title: 'Questionnaires',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/surveys/views/SurveyValidation.vue')
      },
      {
        path: 'manage-content',
        name: 'manage-content',
        meta: {
          title: 'Gestion de contenu',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/manage-content/views/ManageContent.vue')
      },
      {
        path: 'condition/:id',
        name: 'condition-view',
        props: true,
        meta: {
          title: 'Condition',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/conditions/views/ConditionView')
      },
      {
        path: 'patient/:id',
        name: 'patient-edit-profile',
        props: true,
        meta: {
          title: 'Édition du profil'
        },
        component: () => import('src/modules/patients/views/EditProfile.vue')
      },
      {
        path: 'calculated-data/:id/preview',
        name: 'calculated-data-edit',
        props: true,
        meta: {
          title: 'Données calculées',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/calculated-data/views/CalculatedDataView.vue')
      },
      {
        path: 'calculated-data/:id/validation',
        name: 'calculated-data-validation',
        props: true,
        meta: {
          title: 'Données calculées',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/calculated-data/views/CalculatedDataValidation.vue')
      },
      // Statistiques
      {
        path: 'statistics',
        name: 'statistics',
        meta: {
          title: 'Statistiques',
          requiredPrivileges: [ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/stats/views/Statistics.vue')
      },
      {
        path: 'layout-builder',
        name: 'layout-builder',
        meta: {
          title: 'Edition d\'interface',
          requiredPrivileges: [ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value]
        },
        component: () => import('src/modules/layout-builder/views/layoutBuilderFrame.vue')
      },
      {
        path: 'prescriptions',
        name: 'manage-prescriptions',
        component: () => import('src/modules/prescriptions/views/Prescriptions.vue')
      },
      {
        path: 'prescription-generations-batch/:id',
        name: 'prescription-generations-batch-view',
        props: true,
        meta: {
          title: 'Lot de générations de prescriptions',
          requiredPrivileges: [ServicePrivileges.SuperAdmin.value, ServicePrivileges.Manager.value]
        },
        component: () => import('src/modules/prescriptions/views/PrescriptionGenerationsBatch.vue')
      },
      // Liste des professionnels
      {
        path: 'professional-directory',
        name: 'professional-directory',
        meta: {
          title: 'Liste des professionnels',
          requiredPrivileges: [ ServicePrivileges.SuperAdmin.value, ServicePrivileges.Operator.value, ServicePrivileges.Prescriber.value, ServicePrivileges.Manager.value ]
        },
        component: () => import('src/modules/professional-directory/views/ProfessionalView.vue')
      }
    ]
  }
]
